import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { RichText } from 'prismic-reactjs';
import Draggable from 'react-draggable';

import LanguageContext from '../../context/LangContext';

import HistoryItem from './history-item';

const Container = styled.div`
  padding: 68px 0 0;
  background: #EBEBEB;
  overflow: hidden;
  .content {
    max-width: 570px;
    width: 100%;
    margin-bottom: 60px;

    .drag {
      display: none;
    }
    @media (max-width: 789px) {
      .drag {
        display: flex;
        width: 100%;
        font: italic bold 20px 'Times new roman';

        div {
          width: 100%;
        }

        i {
          width: 50px;
          float: left;
          margin: 0 10px 0 0;
        }

        span {
          display: block;

          &:first-child {
            margin-top: 2px;
          }
        }
      }
    }
  }
  h1,
  h2 {
    font: italic bold 36px 'Times new roman';
    margin: 0 0 20px;
  }
  h3 {
    font: italic bold 26px 'Times new roman';
    margin: 0 0 15px;
  }
  P {
    color: #616161;
    font-size: 14px;
    line-height: 24px;
  }
  #history {
    display: flex;
    div {
      padding-bottom: 70px;
      &.first {
        min-width: 180px;
        border-left: 0;
        justify-content: center;
        display: flex;
        height: 515px;
        align-items: center;
        display: flex;
        span {
          font: italic bold 20px 'Times new roman';
          display: block;
          text-align: center;
        }
        @media (max-width: 540px) {
          display: none;
        }
      }
    }
  }
`

const Icon = styled.i`
  display: block;
  height: 50px;
  background: url(/images/arrow-left-right-circle@2x.png) no-repeat center;
  background-size: contain;
  margin: 16px 0;
`

class History extends Component {
  state = {
    pos: 0,
  }

  swipeHandle(event) {
    if (event.deltaX < 0 && this.state.pos > 0) {
      this.setState({pos: this.state.pos + 100})
    } else {
      this.setState({pos: this.state.pos - 100})
    }
  }

  render = () => {
    const { language } = this.context;
    let text1 = ''
    let text2 = ''
    switch (language) {
      case 'pt-br':
        text1 = 'Clique';
        text2 = 'e Arraste';
        break;
      case 'en-us':
        text1 = 'Click';
        text2 = 'and Drag';
        break;
      case 'es-es':
        text1 = 'Hacer clic';
        text2 = 'y arrastrar';
        break;
      default:
    }

    const {titulo, texto, items, link} = this.props;
    return (
      <Container id={ link }>
        <div className="wrapper">
          <div className="content">
            { RichText.render(titulo) }
            { RichText.render(texto) }
            <div className="drag">
              <div>
                <Icon />
                <span>{ text1 }</span>
                <span>{ text2 }</span>
              </div>
            </div>
          </div>
          <Draggable
            axis="x">
            <div id="history" >
              <div className="first">
                <div>
                  <span>{ text1 }</span>
                  <Icon />
                  <span>{ text2 }</span>
                </div>
              </div>
              {
                items.map((item, index) => {
                  return (
                    <HistoryItem {...item} key={ index } />
                  )
                })
              }
            </div>
          </Draggable>
        </div>
      </Container>
    )
  }
}

History.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
};

History.contextType = LanguageContext;

export default History;
